// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__CZlqH","footer":"Form_footer__-NAAw"};